<template>
	<div>
		<notifications position="top center" group="info" />

		<h1>Utilisateur</h1>
		<span>Identifiant</span>
		<b-input v-model="user.identifiant"></b-input>
		<span>Prénom</span>
		<b-input v-model="user.prenom"></b-input>
		<span>Nom</span>
		<b-input v-model="user.nom"></b-input>
		<span>Email</span>
		<b-input v-model="user.email"></b-input>
		<span>Password - laissez vide pour envoyer un mail de définition pour un nouvel utilisateur ou ne pas le changer pour un utilisateur existant</span>
		<b-input-group>
			<b-input
				:type="showPassword ? 'text' : 'password'"
				v-model="user.password"
				autocomplete="new-password"
				name="user_password_field"></b-input>
			<template #append>
				<b-button
					variant="outline-secondary"
					@click="showPassword = !showPassword">
					<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
				</b-button>
			</template>
		</b-input-group>
		<p>
			Token API (JWT) :
			<strong v-if="user.jwt" class="text-success">Défini</strong>
			<strong v-else class="text-muted">Aucun token défini</strong>
			<b-button variant="link" @click="generate_jwt">Générer un nouveau token</b-button>
		</p>
		<pre v-if="user.jwt">{{ user.jwt }}</pre>
		<p v-if="user.token_new_password">
			Token de réinitialisation du mot de passe : {{ user.token_new_password }}
			<b-button variant="link" @click="show_password_reset_url">Voir l'url de réinitialisation</b-button>
		</p>
		<p v-else>
			Aucun token de réinitialisation du mot de passe défini
			<b-button variant="link" @click="generate_password_reset_token">Générer un token</b-button>
		</p>
		<b-input-group v-if="passwordResetUrl" class="mb-3">
			<b-form-input readonly :value="passwordResetUrl"></b-form-input>
			<template #append>
				<b-button variant="outline-secondary" @click="copy_password_reset_url">Copier</b-button>
			</template>
		</b-input-group>
		<span
			>Actif<b-checkbox
				value="oui"
				unchecked-value="non"
				v-model="user.actif"></b-checkbox
		></span>
		<p>Groupes</p>
		<b-form-select
			@change="actual_group = user.groups[0]"
			multiple
			v-model="user.groups"
			:options="group"
			></b-form-select>
		<br /><br />
		<p>Groupe actuel</p>
		<b-form-select
			v-model="actual_group"
			:options="group"
			></b-form-select>
		<br /><br />
		<p>Environnement</p>
		<b-form-select v-model="user.env" :options="env_list"></b-form-select>
		<h4>Champs complémentaires</h4>
		<div v-for="field in client.details.profile" :key="field.name">
			<div class="form-inline">
				<div class="form-group" style="margin-bottom: 10px">
					<span>{{ field.libelle }} : &nbsp;</span>
					<b-form-input
						:type="field.type"
						v-if="field.type != 'checkbox'"
						v-model="user.details[field.name]"></b-form-input>
					<b-checkbox
						v-else
						v-model="user.details[field.name]"></b-checkbox>
				</div>
			</div>
		</div>
		<br />
		<div v-if="user.last_date_login">
			<p>Date de dernière connexion : {{user.last_date_login}}</p>
		</div>
		<div v-if="user.details.register">
			<h4>Validation d'inscription</h4>
			<p>Token de validation d'inscription : {{user.details.register}}</p>
			<p>Url de validation d'inscription : {{user.details.register_url}}</p>
		</div>
		<b-button @click="update">Mettre à jour</b-button>
	</div>
</template>

<script>
	import store from "../store";

	import users from "../services/users.js";
	import client from "../services/client.js";

	export default {
		name: "user",
		data() {
			return {
				user: { 
					uid: this.$route.params.id,
					groups: [],
					details: {
						register: {}
					}
				 },
				group: [""],
				actual_group: "",
				client: {
					details: {
						profile: {},
					}
				},
				env_list: [""],
				showPassword: false,
				passwordResetUrl: null,
			};
		},
		methods: {
			update: async function () {
				var user = await users.updateUser(this.user, this.actual_group);

				if (user) {
					this.$notify({
						group: "info",
						title: "Modification sur l'utilisateur enregistré",
						type: "success",
					});

					console.log(user)
					if (user.jwt)
						this.$set(this.user, "jwt", user.jwt);
				} else {
					this.$notify({
						group: "info",
						title: "Un erreur c'est produite durant l'enregistrement, l'identifiant existe peut-être déjà ou vous n'avez pas les droits",
						type: "error",
					});
				}
			},
			async generate_jwt()
			{
				this.user.jwt = await users.generateJwt(this.user.uid);
			},
			async generate_password_reset_token()
			{
				var token = await users.generatePasswordResetToken(this.user.uid);

				if (token) {
					this.$set(this.user, "token_new_password", token);
					this.show_password_reset_url();
				} else {
					this.$notify({
						group: "info",
						title: "Une erreur est survenue lors de la génération du token",
						type: "error",
					});
				}
			},
			show_password_reset_url()
			{
				this.passwordResetUrl = window.location.origin + "/password/" + this.user.token_new_password;
			},
			copy_password_reset_url()
			{
				navigator.clipboard.writeText(this.passwordResetUrl);
				this.$notify({
					group: "info",
					title: "Url copiée dans le presse-papier",
					type: "success",
				});
			},
		},
		created: async function () {
			if (
				store.state.user.rules &&
				!store.state.user.rules.utilisateurs
			) {
				this.$router.push({ name: "profile" });
			}

			if (this.$route.params.id)
			{
				var user = await users.getUser(this.$route.params.id);

				if (user)
				{
					this.user = user;
					if (this.user.groups)
					{
						this.user.groups = this.user.groups.split("|");
						this.actual_group = this.user.groups[0];
					}
					else 
						this.user.groups = [];
				}
				else
					this.user = null;	
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			console.log(this.client)

			if (!this.client.details) 
				this.client.details = {};

			if (!this.client.details.profile) 
				this.client.details.profile = {};

			if (!this.user) {
				this.user = {
					uid: this.$route.params.id,
					nom: "",
					prenom: "",
					identifiant: "",
					mot_de_passe: "",
					client_uid: store.state.user.client_uid,
					token_new_password: "",
					email: "",
					groups: [],
					rules: [],
					archive: false,
					details: {},
					env: "",
				};
			}

			if (!this.user.details) this.user.details = {};

			this.user.password = "";

			var groups = await client.getClientGroups();

			var obj_groups = {};
			for (var i = 0; i < groups.length; i++) {
				obj_groups[groups[i].uid] = groups[i];
				this.group.push({
					value: groups[i].uid,
					text: groups[i].name,
				});
			}

			if (this.user.archive) this.user.actif = "non";
			else this.user.actif = "oui";

			this.env_list = [""];
			var keys = Object.keys(this.client.details.env);
			for (var i = 0; i < keys.length; i++) {
				this.env_list.push({
					text: this.client.details.env[keys[i]].name,
					value: keys[i],
				});
			}
		},
	};
</script>

<style></style>
